import { render } from "./enrolmentStep3_1.vue?vue&type=template&id=862332a2&slot=OneClass"
import script from "./enrolmentStep3_1.vue?vue&type=script&lang=js"
export * from "./enrolmentStep3_1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__